export default "__VITE_ASSET__rsir4PlO__"